import React, { useState } from "react";
import styled from "styled-components/macro";
import { Grid, Row, Col } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import SelectGuides from "./components/select-guides.component";
import CreateGuide from "./components/create-guide.component";

export default function GuidesScreen() {
  const [mode, setMode] = useState("select"); // "select" | "create"
  return (
    <div className="main-content">
      <ModeSelector>
        <Mode active={mode === "select"} onClick={() => setMode("select")}>
          Display all guides
        </Mode>
        <Mode active={mode === "create"} onClick={() => setMode("create")}>
          Create a guide
        </Mode>
      </ModeSelector>
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Card
              title={
                mode === "select"
                  ? "All guides"
                  : mode === "create"
                  ? "Create a guide"
                  : ""
              }
              content={
                mode === "select" ? (
                  <SelectGuides />
                ) : mode === "create" ? (
                  <CreateGuide />
                ) : null
              }
            />
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

const ModeSelector = styled.div`
  margin-bottom: 12px;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

const Mode = styled.div`
  transition: all 200ms ease;
  cursor: pointer;
  user-select: none;
  padding: 8px 24px;
  margin-right: 8px;
  font-size: 14px;
  border-bottom: 2px solid
    ${(props) => (props.active ? "#cecece" : "transparent")};

  &:hover {
    background-color: #cecece;
  }
`;
